module.exports = __webpack_public_path__ + "img/skype_colored.01a69ea6.svg";